import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiMail, FiLock, FiEye, FiEyeOff, FiUser } from "react-icons/fi";
import { FaGoogle, FaGithub } from "react-icons/fa";
import { useApp } from "../context/AppContext";

export default function SignUpForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { signup } = useApp();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      const success = signup(email, password, confirmPassword);
      setLoading(false);
      if (success) navigate("/dashboard");
    }, 800);
  };

  const inputStyle = { borderRadius: "0 10px 10px 0", border: "2px solid var(--gray-200)", borderLeft: "none" };
  const iconStyle = { borderRadius: "10px 0 0 10px", border: "2px solid var(--gray-200)" };

  return (
    <div className="auth-card fade-in-up">
      <div className="auth-header">
        <h2>Create Account</h2>
        <p>Join Home Discovery and find your dream home</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Full Name</label>
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0" style={iconStyle}>
              <FiUser className="text-muted" />
            </span>
            <input
              className="form-control border-start-0"
              type="text"
              placeholder="John Doe"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={inputStyle}
            />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Email Address</label>
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0" style={iconStyle}>
              <FiMail className="text-muted" />
            </span>
            <input
              className="form-control border-start-0"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={inputStyle}
            />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Password</label>
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0" style={iconStyle}>
              <FiLock className="text-muted" />
            </span>
            <input
              className="form-control border-start-0 border-end-0"
              type={showPassword ? "text" : "password"}
              placeholder="Min 6 characters"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ border: "2px solid var(--gray-200)", borderLeft: "none", borderRight: "none" }}
            />
            <button
              type="button"
              className="input-group-text bg-white border-start-0"
              onClick={() => setShowPassword(!showPassword)}
              style={{ borderRadius: "0 10px 10px 0", border: "2px solid var(--gray-200)", borderLeft: "none", cursor: "pointer" }}
            >
              {showPassword ? <FiEyeOff className="text-muted" /> : <FiEye className="text-muted" />}
            </button>
          </div>
        </div>

        <div className="mb-4">
          <label className="form-label">Confirm Password</label>
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0" style={iconStyle}>
              <FiLock className="text-muted" />
            </span>
            <input
              className="form-control border-start-0"
              type={showPassword ? "text" : "password"}
              placeholder="Repeat your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={inputStyle}
            />
          </div>
          {password && confirmPassword && password !== confirmPassword && (
            <small className="text-danger mt-1 d-block">Passwords don't match</small>
          )}
        </div>

        <div className="form-check mb-3">
          <input className="form-check-input" type="checkbox" id="terms" required />
          <label className="form-check-label small text-muted" htmlFor="terms">
            I agree to the <a href="#!" className="text-decoration-none" style={{ color: "var(--primary)" }}>Terms of Service</a> and{" "}
            <a href="#!" className="text-decoration-none" style={{ color: "var(--primary)" }}>Privacy Policy</a>
          </label>
        </div>

        <button className="btn btn-auth" type="submit" disabled={loading}>
          {loading ? (
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          ) : null}
          {loading ? "Creating Account..." : "Create Account"}
        </button>
      </form>

      <div className="divider">or sign up with</div>

      <div className="d-flex gap-2">
        <button className="social-btn">
          <FaGoogle style={{ color: "#ea4335" }} /> Google
        </button>
        <button className="social-btn">
          <FaGithub /> GitHub
        </button>
      </div>

      <p className="text-center mt-3 mb-0 small text-muted">
        Already have an account?{" "}
        <Link to="/login" className="text-decoration-none fw-semibold" style={{ color: "var(--primary)" }}>
          Sign in
        </Link>
      </p>
    </div>
  );
}
